import { useCallback, useEffect, useState } from 'react'
import { getLog } from '../lib/notes.js'

const FILTERS = [
  { key: 'all',  label: 'Everything' },
  { key: 'said', label: 'What I said' },
  { key: 'made', label: 'Made' },
  { key: 'done', label: 'Finished' },
]

/** Day one it is a receipt. Month six it is a diary. */
/* Kept in step with the shell: only these can be opened from a Log line. */
const OPENABLE = new Set(['account', 'build', 'installment', 'payout', 'payable', 'topic', 'project'])

export default function Log({ refreshKey, onOpenRecord }) {
  const [filter, setFilter] = useState('all')
  const [rows, setRows] = useState(null)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setError(null)
    try {
      setRows(await getLog(filter))
    } catch (e) {
      setError(e.message || String(e))
    }
  }, [filter])

  useEffect(() => { load() }, [load, refreshKey])

  let lastDay = null

  return (
    <>
      <div className="page-head">
        <span className="lbl">The Log</span>
        <h1 className="serif">Everything, in order</h1>
      </div>

      <div className="filters" role="group" aria-label="Filter the log">
        {FILTERS.map((f) => (
          <button
            key={f.key}
            type="button"
            aria-pressed={filter === f.key}
            onClick={() => setFilter(f.key)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {error ? <div className="notice warn"><p style={{ margin: 0, fontSize: 14 }}>{error}</p></div> : null}
      {!rows && !error ? <p className="lbl" style={{ padding: '20px 2px' }}>Loading…</p> : null}

      {rows && rows.length === 0 ? (
        <div className="empty">
          <h2 className="serif">Nothing logged yet</h2>
          <p>Every capture, tick and payment lands here automatically.</p>
        </div>
      ) : null}

      {rows?.map((r) => {
        const d = new Date(r.happened_at)
        const day = d.toDateString()
        const newDay = day !== lastDay
        lastDay = day
        return (
          <div key={r.id}>
            {newDay ? (
              <p className="lbl logday">
                {d.toLocaleDateString('en-PH', { weekday: 'long', day: 'numeric', month: 'long' })}
              </p>
            ) : null}
            {r.target_id && OPENABLE.has(r.target_type) && onOpenRecord ? (
              <button
                type="button"
                className="logrow logrow-open"
                onClick={() => onOpenRecord({ type: r.target_type, id: r.target_id })}
                aria-label={'Open the record behind: ' + r.summary}
              >
                <span className="logtime num">
                  {d.toLocaleTimeString('en-PH', { hour: 'numeric', minute: '2-digit' })}
                </span>
                <span className="logbody">{r.summary}</span>
                <span className="go" aria-hidden="true">›</span>
              </button>
            ) : (
              <div className="logrow">
                <span className="logtime num">
                  {d.toLocaleTimeString('en-PH', { hour: 'numeric', minute: '2-digit' })}
                </span>
                <span className="logbody">{r.summary}</span>
              </div>
            )}
          </div>
        )
      })}
    </>
  )
}
